import { BRAND } from "./brand";

export function getArticleSchema(article: { title: string; description: string; slug: string; author: string; date: string; image?: string }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.description,
    author: { "@type": "Person", name: article.author },
    datePublished: article.date,
    publisher: {
      "@type": "Organization",
      name: BRAND.name,
      url: BRAND.url,
    },
    mainEntityOfPage: `${BRAND.url}/blog/${article.slug}`,
    ...(article.image && { image: article.image }),
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
}

export function getSoftwareApplicationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: BRAND.name,
    applicationCategory: "HealthApplication",
    operatingSystem: "Web",
    description:
      "Myelina Health helps women with MS see their energy patterns and plan the day around them, guided by Myelina, an AI energy companion. Calm, predictive, designed for invisible fatigue.",
    // Invite-only. No public offers surfaced in structured data.
    url: BRAND.url,
  };
}

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BRAND.nameSafe,
    legalName: BRAND.legalName,
    url: BRAND.url,
    logo: `${BRAND.url}/pwa-512.png`,
    description: BRAND.shortDescription,
    sameAs: [],
  };
}
